export function useExchangeRate() {
  const userStore = useUserStore()
  const { userBalance } = storeToRefs(userStore)
  const { multiply, divide } = useMath()
  /**
   * @description 格式化价格
   * @param num 价格
   * @param step 保留小数位数 默认2位
   **/
  const formatPriceToFixed = (num: number | string, step = 2) => {
    if (!num) return '0'
    const numStr = num.toString()
    const decimalIndex = numStr.indexOf('.')
    if (decimalIndex !== -1) {
      // 截取小数点后的部分，根据 step 精度截取
      const decimalPart = numStr.substring(decimalIndex + 1, decimalIndex + 1 + step)
      return `${numStr.substring(0, decimalIndex)}.${decimalPart}`
    } else {
      // 如果没有小数点，则直接返回原始值
      return numStr
    }
  }
  /**
   * @description ETH转USD
   * @param price ETH价格
   * @param step 保留小数位数 默认2位
   **/
  const useUSD = (price: number, step = 2) => {
    if (!userBalance.value?.usdRate || !price) return 0
    return formatPriceToFixed(multiply(price, userBalance.value.usdRate), step)
  }
  /**
   * @description USD转ETH
   * @param price 美金价格
   * @param step 保留小数位数 默认4位
   **/
  const useETH = (price: number, step = 4) => {
    if (!userBalance.value?.usdRate || !price) return 0
    return formatPriceToFixed(divide(price, userBalance.value?.usdRate), step)
      .toString()
      .replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
  }

  /**
   * @description USD转Stars
   * @param price 美金价格
   * @param step 整数
   **/

  const useStars = (price: number) => {
    if (!userBalance.value?.usdToStarsRate || !price) return 0
    return Math.ceil(multiply(price, userBalance.value.usdToStarsRate))
  }

  /**
   * @description USD转SOL
   * @param price 美金价格
   * @param step 整数
   **/
  const useSOL = (price: number, step = 6) => {
    if (!userBalance.value?.solToUsdRate || !price) return 0
    return formatPriceToFixed(divide(price, userBalance.value?.solToUsdRate), step)
      .toString()
      .replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
  }

  return {
    useUSD,
    useETH,
    formatPriceToFixed,
    useStars,
    useSOL,
  }
}
